import api from "src/api/axiosInstance";

export const subscribeUser = async (email) => {
  try {
    const response = await api.post(
      "/subscribe",
      { email },
    );   
    return response.data?.ID ? "You have successfully subscribed!" : null;
  } catch (error) {
    console.error("Subscription failed:", error);
    return null;
  }
};
